import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import './CatalogConfirmation.css';

const CatalogConfirmation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const message = location.state?.message || 'Thank you, our team will contact you.';

  return (
    <section className="catalog-thankyou-page">
      <div className="catalog-thankyou-card">
        <FaCheckCircle className="catalog-thankyou-icon" />
        <p className="catalog-thankyou-kicker">Catalogue Request Received</p>
        <h1>{message}</h1>
        <p className="catalog-thankyou-subtitle">
          Your enquiry has been shared with our sales team.
        </p>

        <button
          type="button"
          className="catalog-thankyou-btn"
          onClick={() => navigate('/catalog')}
        >
          Back to Catalogue
        </button>
      </div>
    </section>
  );
};

export default CatalogConfirmation;
